import { pick } from 'lodash-es';
import { get } from 'lodash-es';

export function nameValueImage(arry: any[], imagePath: string) {
  return arry.map((item) => {
    return {
      value: item.id,
      name: item.name,
      image: get(item, imagePath),
    };
  });
}
